import {
	access_check_lists_history,
	access_history, access_questionnaire, access_questionnaire_history,
	access_statistics,
	statistics_view_aging,
	statistics_view_asset_cost,
	statistics_view_completed_within_SLA,
	statistics_view_mtbf,
	statistics_view_nmpi,
	statistics_view_repeat_wo,
	view_non_completed_checklists,
	view_po
} from "../../../../helpers/rights/rights";
import { getRouteUrl } from "../../../../helpers/routing/getRouteUrl";
import { ROUTE_PAGE_ISSUES_INDEX } from "../../../../modules/issues/routes/routes";
import {
	ROUTE_PAGE_AGING,
	ROUTE_PAGE_PURCHASES_ORDER,
	ROUTE_PAGE_ASSET_COST,
	ROUTE_PAGE_CHECK_LISTS_HISTORY,
	ROUTE_PAGE_CHECK_LISTS_HISTORY_NO_PDF,
	ROUTE_PAGE_COMPLETED_WITHIN_SLA,
	ROUTE_PAGE_HOME,
	ROUTE_PAGE_MTBF,
	ROUTE_PAGE_NMPI,
	ROUTE_PAGE_REPEAT_WO,
	ROUTE_PAGE_NON_COMPLETED_CHECKLISTS_INDEX,
	ROUTE_PAGE_USER_QUESTIONNAIRE, ROUTE_PAGE_USER_QUESTIONNAIRE_HISTORY, ROUTE_PAGE_PLANNED_MAINTENANCE
} from "../../../../routers/routes";
import { CHECKLISTS, REPORTS } from "../../../../locales/pages/namespaces";

export const menuOptions = ({
								t
							}) => ([
	{
		icon: 'DashboardOutlined',
		id: 'group-dashboard',
		title: '',
		type: 'group',
		children: [
			{
				id: 'home',
				url: getRouteUrl(ROUTE_PAGE_HOME),
				title: t("Home"),
				permissions: [],
				icon: 'HomeIcon',
				hoverMessage: t("Home"),
				type: 'item'
			},
			{
				id: 'issues',
				url: getRouteUrl(ROUTE_PAGE_ISSUES_INDEX),
				title: t("Issues"),
				permissions: [access_history],
				icon: 'ListIcon',
				hoverMessage: t("Issues"),
				type: 'item'
			},
			{
				id: 'check-lists-history',
				url: getRouteUrl(ROUTE_PAGE_CHECK_LISTS_HISTORY),
				title: t("Check Lists History", { ns: CHECKLISTS }),
				permissions: [access_check_lists_history],
				icon: 'GradeIcon',
				hoverMessage: t("Check Lists History", { ns: CHECKLISTS }),
				type: 'item'
			},
			{
				id: 'check-lists-history-no-pdf',
				url: getRouteUrl(ROUTE_PAGE_CHECK_LISTS_HISTORY_NO_PDF),
				title: t("Space management", { ns: CHECKLISTS }),
				permissions: [access_check_lists_history],
				icon: 'GradeIcon',
				hoverMessage: t("Space management", { ns: CHECKLISTS }),
				type: 'item'
			},
			{
				id: 'questionnaire',
				url: getRouteUrl(ROUTE_PAGE_USER_QUESTIONNAIRE),
				title: t("Questionnaire", { ns: CHECKLISTS }),
				permissions: [access_questionnaire],
				icon: 'ChecklistIcon',
				hoverMessage: t("Questionnaire", { ns: CHECKLISTS }),
				type: 'item'
			},
			{
				id: 'questionnaires-history',
				url: getRouteUrl(ROUTE_PAGE_USER_QUESTIONNAIRE_HISTORY),
				title: t("Questionnaire History", { ns: CHECKLISTS }),
				permissions: [access_questionnaire_history],
				icon: 'ChecklistIcon',
				hoverMessage: t("Questionnaire History", { ns: CHECKLISTS }),
				type: 'item'
			},
			{
				icon: 'ReportsIcon',
				id: 'reports',
				title: t("Reports", { ns: REPORTS }),
				type: 'collapse',
				permissions: [access_statistics],
				children: [
					{
						id: 'reports-completed-within-sla',
						url: getRouteUrl(ROUTE_PAGE_COMPLETED_WITHIN_SLA),
						title: t("Completed Within SLA", { ns: REPORTS }),
						permissions: [statistics_view_completed_within_SLA],
						// icon: 'HomeIcon',
						hoverMessage: t("Completed Within SLA", { ns: REPORTS }),
						type: 'item'
					},
					{
						id: 'reports-planned-maintenance',
						url: getRouteUrl(ROUTE_PAGE_PLANNED_MAINTENANCE),
						title: t("Planned Maintenance"),
						permissions: [statistics_view_completed_within_SLA],
						// icon: 'HomeIcon',
						hoverMessage: t("Planned Maintenance"),
						type: 'item'
					},
					{
						id: 'reports-repeat-wo',
						url: getRouteUrl(ROUTE_PAGE_REPEAT_WO),
						title: t("Repeat Workorder", { ns: REPORTS }),
						permissions: [statistics_view_repeat_wo],
						// icon: 'HomeIcon',
						hoverMessage: t("Repeat Workorder", { ns: REPORTS }),
						type: 'item'
					},
					{
						id: 'reports-mtbf',
						url: getRouteUrl(ROUTE_PAGE_MTBF),
						title: t("MTBF", { ns: REPORTS }),
						permissions: [statistics_view_mtbf],
						// icon: 'HomeIcon',
						hoverMessage: t("MTBF", { ns: REPORTS }),
						type: 'item'
					},
					{
						id: 'reports-nmpi',
						url: getRouteUrl(ROUTE_PAGE_NMPI),
						title: t("NMPI", { ns: REPORTS }),
						permissions: [statistics_view_nmpi],
						// icon: 'HomeIcon',
						hoverMessage: t("NMPI", { ns: REPORTS }),
						type: 'item'
					},
					{
						id: 'reports-asset-cost',
						url: getRouteUrl(ROUTE_PAGE_ASSET_COST),
						title: t("Asset Cost", { ns: REPORTS }),
						permissions: [statistics_view_asset_cost],
						// icon: 'HomeIcon',
						hoverMessage: t("Asset Cost", { ns: REPORTS }),
						type: 'item'
					},
					{
						id: 'reports-aging',
						url: getRouteUrl(ROUTE_PAGE_AGING),
						title: t("Ageing", { ns: REPORTS }),
						permissions: [statistics_view_aging],
						// icon: 'HomeIcon',
						hoverMessage: t("Ageing", { ns: REPORTS }),
						type: 'item'
					},
					{
						id: 'reports-purchases-order',
						url: getRouteUrl(ROUTE_PAGE_PURCHASES_ORDER),
						title: t("P.O", { ns: REPORTS }),
						permissions: [view_po],
						hoverMessage: t("P.O", { ns: REPORTS }),
						type: 'item'
					},
					{
						id: 'reports-non-completed-checklists',
						url: getRouteUrl(ROUTE_PAGE_NON_COMPLETED_CHECKLISTS_INDEX),
						title: t("Non Completed Checklists", { ns: CHECKLISTS }),
						permissions: [view_non_completed_checklists],
						hoverMessage: t("Non Completed Checklists", { ns: CHECKLISTS }),
						type: 'item'
					}
				]
			}
		]
	}])